"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisabledGradingTaskArgs = exports.ManyGradingTaskArgs = exports.OneGradingTaskArgs = exports.DefaultGradingTaskArgs = void 0;
exports.DefaultGradingTaskArgs = {};
exports.OneGradingTaskArgs = {
    amount: 1,
    showGradingTaskButton: true,
};
exports.ManyGradingTaskArgs = {
    amount: 5,
    showGradingTaskButton: true,
};
exports.DisabledGradingTaskArgs = {
    amount: 0,
    disabled: true,
    showGradingTaskButton: true,
};
